import { useGetGuidParam } from '@risksmart-app/components/src/routes/routes.utils';
import { Parent_Type_Enum } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useTranslation } from 'react-i18next';
import { ObjectToolbar } from 'src/blocks/object-toolbar';
import ControlledTabs from 'src/components/controlled-tabs';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import useTabs from '@/hooks/useTabs';
import { riskDetailsUrl } from '@/utils/urls';

import PageLayout from '../../../../layouts/PageLayout';

const Page = () => {
  const riskId = useGetGuidParam('riskId');
  const objectToolbarEnabled = useIsFeatureFlagEnabled('object_toolbar');
  const tabs = useTabs({
    parentType: Parent_Type_Enum.Acceptance,
    parent: null,
    hrefRoot: `${riskDetailsUrl(riskId)}/acceptance/add`,
  });
  const { t: st } = useTranslation(['common'], { keyPrefix: 'acceptances' });
  const title = st('create_modal_title');

  return (
    <PageLayout
      title={title}
      // Object-level toolbar (CUS-158) — flag-gated, title-only. The create
      // surface has no relocated actions; the AcceptanceForm keeps its own
      // Create/Cancel buttons.
      headerOverride={
        objectToolbarEnabled ? (
          <ObjectToolbar config={{ header: { title } }} />
        ) : undefined
      }
    >
      <ControlledTabs
        tabs={tabs}
        variant={'container'}
        parentType={Parent_Type_Enum.Acceptance}
        disableSettings
      />
    </PageLayout>
  );
};

export default Page;
